'use client';

import { HStack, Box } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';

type DetailRowProps = {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
};

export const DetailRow = ({ label, value, icon }: DetailRowProps) => {
  return (
    <HStack
      gap="4"
      w="full"
      justifyContent="space-between"
      alignItems="center"
      py="4"
      borderBottomWidth="1px"
      borderBottomColor="border.subtle"
    >
      <HStack gap="2" alignItems="center">
        {icon && <Box color="fg.muted">{icon}</Box>}
        <Box fontSize="sm" color="fg.muted" fontWeight="medium">
          {label}
        </Box>
      </HStack>
      <Box fontSize="sm" color="fg.default">
        {value}
      </Box>
    </HStack>
  );
};
